import { render, staticRenderFns } from "./ball.vue?vue&type=template&id=2f67a8c3&scoped=true&"
var script = {}
import style0 from "./ball.vue?vue&type=style&index=0&id=2f67a8c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f67a8c3",
  null
  
)

export default component.exports